<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1ULyEH/tc-custom/9781449418175.jpg?1737753763628" alt="This image is the cover for the book I Love Corn"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I Love Corn
      </h1>
      <p class="bookDescription body article font2">
        <b>A gathering of fifty of the best corn recipes from around the world, including soups, appetizers, entrees, and desserts.</b><br/><br/>Some of the dishes you’ll find are Jalapeno Corn Muffins; Sweet Corn Fritters; Fresh Corn Gazpacho; Grilled New Zealand Venison with Corn, Cocoa and Chipotle Relish; Polenta Stew; Corn Pudding with Bacon and Leeks; Yankee Corn Bread; Popcorn Pudding with Salted Caramel Corn and Butterscotch Sauce; and Fresh Corn Ice Cream. Also inside this colorful, gift-worthy package you’ll find tips for buying, storing, cooking, and grilling fresh corn, along with instructions for easily cutting kernels off the cob.<br/><br/>With recipes that have been painstakingly crafted by creative, award-winning chefs from around the country, such as Dan Barber, Michelle Bernstein, Hugh Acheson, and Gabriel Rucker, <i>I Love Corn</i> makes corn the irresistible ingredient of choice for all of your favorite dishes.<br/><br/><b>A whopping 75% of the proceeds will go directly to The Dougy Center (www.dougy.org), the National Center for Grieving Children &amp; Families.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Skye
      </h2>
      
      <p class="authorDescription body article">Born and raised in South Florida, author Lisa Skye moved to New York City in 1998 to study broadcast journalism at New York University. After years of working with highly reputable restaurants, including Union Square Cafe, Blue Hill, and The Odeon, she went on to anchor and produce for PBS, and then field produced the Discovery Channel's premier food show Go Ahead, Make My Dinner. A natural connector, Lisa serves as a president and director for an organization called Business Network International. Currently, she works in commercial real estate investments and development. She lives in Brooklyn, and plans to retire somewhere near a beach.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Demo
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?682cd9f0